import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirect a renamed route, keeping the query string and hash so deep links still land on the
 * same filter or record (e.g. /approvals?formId=123 -> /submissions?formId=123).
 */
const RedirectPreservingQuery: React.FC<{ to: string }> = ({ to }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
};

export default RedirectPreservingQuery;
